/**
 * incollaPulito.js — riduce l'HTML incollato all'insieme ammesso.
 *
 * PERCHE' PRIMA DI PROSEMIRROR E NON SOLO DOPO
 * Lo schema di ProseMirror scarta i nodi che non conosce, ed e' la
 * difesa che conta. Ma le regole di lettura di TipTap riconoscono anche
 * la formattazione scritta come ATTRIBUTO: uno
 * `<span style="font-weight:bold">` incollato da Word diventa grassetto
 * per una strada che la barra degli strumenti non controlla, e un
 * `<p class="MsoTitle">` si porta dietro una gerarchia che non e' la
 * nostra. Togliere gli attributi prima chiude quella strada.
 *
 * E' UNA FUNZIONE A SE' PER POTERLA PROVARE. Dentro l'editor sarebbe
 * codice che si verifica solo incollando a mano, e incollare a mano non
 * e' una prova che resta.
 *
 * NON SOSTITUISCE LA RIPULITURA SUL SERVER. Questa gira sul computer di
 * chi scrive, e da li' non si crede mai niente.
 */

/* Gli attributi che portano tipografia o provenienza. Lista chiusa: si
   tolgono questi e basta, perche' togliere TUTTI gli attributi
   spezzerebbe anche `href` e i livelli dei titoli. */
const ATTRIBUTI = 'style|class|lang|bgcolor|color|face|size|width|height|align|dir';

/* Questi si tolgono CON IL LORO CONTENUTO. Togliere solo i tag
   lascerebbe il testo dentro: un `<style>p{color:red}</style>` incollato
   diventerebbe la riga «p{color:red}» in mezzo al referto. Trovato
   provando, non leggendo. */
const TAG_CON_CONTENUTO = 'style|script|xml|svg|object|iframe';

/* Questi si tolgono soltanto come tag, e cio' che contengono resta: il
   testo dentro un `<font>` e' testo del referto. `o:p` e `w:*` sono i
   residui di Word. */
const TAG = 'o:p|w:[a-z]+|meta|link|font|img';

export function incollaPulito(html) {
    if (!html) return '';
    return String(html)
        // I commenti condizionali di Word contengono interi frammenti di HTML
        .replace(/<!--[\s\S]*?-->/g, '')
        .replace(new RegExp(`<(${TAG_CON_CONTENUTO})\\b[^>]*>[\\s\\S]*?<\\/\\1>`, 'gi'), '')
        .replace(new RegExp(`<\\/?(?:${TAG_CON_CONTENUTO}|${TAG})\\b[^>]*>`, 'gi'), '')
        .replace(new RegExp(`\\s(?:${ATTRIBUTI})\\s*=\\s*"[^"]*"`, 'gi'), '')
        .replace(new RegExp(`\\s(?:${ATTRIBUTI})\\s*=\\s*'[^']*'`, 'gi'), '')
        // Attributi senza virgolette: <p align=center>
        .replace(new RegExp(`\\s(?:${ATTRIBUTI})\\s*=\\s*[^\\s>]+`, 'gi'), '');
}

export default incollaPulito;
